import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTASectionProps {
  setIsFormOpen: (isOpen: boolean) => void;
}
export const CTASection = ({
  setIsFormOpen
}: CTASectionProps) => {
  return <section className="py-20 px-4 bg-gradient-to-br from-indigo-900 to-slate-900 text-white" data-id="element-31">
      <div className="max-w-5xl mx-auto text-center" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-33">
          Be the First to Experience Autonomous Tech Support
        </h2>
        <p className="text-xl mb-10 text-indigo-100" data-id="element-34">
          Join our waitlist to get early access and special launch pricing.
        </p>
        <button onClick={() => setIsFormOpen(true)} className="bg-indigo-600 px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition flex items-center justify-center mx-auto" data-id="element-35">
          Join Waitlist
          <ArrowRight className="ml-2 h-5 w-5" data-id="element-36" />
        </button>
        <div className="mt-12 flex flex-wrap justify-center gap-8" data-id="element-37">
          <div className="text-center" data-id="element-38">
            <div className="text-4xl font-bold text-indigo-300" data-id="element-39">100%</div>
            <div className="text-indigo-200" data-id="element-40">Autonomous</div>
          </div>
          <div className="text-center" data-id="element-41">
            <div className="text-4xl font-bold text-indigo-300" data-id="element-42">24/7</div>
            <div className="text-indigo-200" data-id="element-43">Support</div>
          </div>
          <div className="text-center" data-id="element-44">
            <div className="text-4xl font-bold text-indigo-300" data-id="element-45">2</div>
            <div className="text-indigo-200" data-id="element-46">OS Platforms</div>
          </div>
          <div className="text-center" data-id="element-47">
            <div className="text-4xl font-bold text-indigo-300" data-id="element-48">0</div>
            <div className="text-indigo-200" data-id="element-49">Human Intervention</div>
          </div>
        </div>
      </div>
    </section>;
};